import * as React from 'react';
import { colors } from '../../../index';

const IconEvent = ({
  className = '',
  size = '1em',
  color,
  style = {}
}) => {
  const finalStyle = { ...style,
    fill: colors[color],
    color: colors[color]
  };
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 35 30",
    width: size,
    height: size,
    style: finalStyle,
    className: `icon ${className}`
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5a4.042 4.042 0 00-3.365-3.978V8.808c0-.523-.293-.988-.764-1.215a1.34 1.34 0 00-1.427.162l-5.381 4.305c-.02.016-.035.037-.055.055h-7.854a3.37 3.37 0 00-3.366 3.365h-1.346c-.742 0-1.346.604-1.346 1.346v1.346c0 .743.604 1.347 1.346 1.347h1.346a3.37 3.37 0 003.366 3.365v4.038a2.695 2.695 0 002.692 2.693 2.695 2.695 0 002.692-2.693v-4.038h2.47c.02.017.034.038.055.055l5.381 4.305a1.34 1.34 0 001.427.162c.47-.226.764-.692.764-1.214v-4.714A4.042 4.042 0 0035 17.5zm-23.558.673v-1.346h1.346v1.346h-1.346zm8.75 8.75c0 .742-.603 1.346-1.346 1.346a1.348 1.348 0 01-1.346-1.346v-4.038h2.692v4.038zm-4.038-5.385a2.022 2.022 0 01-2.02-2.019v-4.038c0-1.114.907-2.02 2.02-2.02h7.404v8.077h-7.404zm14.132 4.655l-5.382-4.306v-8.776l2.692-2.152V17.5h1.346V9.883l1.346-1.075.002 17.388s-.002 0-.004-.003zm1.349-6.096v-5.194a2.69 2.69 0 012.019 2.597 2.69 2.69 0 01-2.02 2.597zM15.48 16.154c0-.743.604-1.346 1.346-1.346h1.346v1.346h-1.346V17.5H15.48v-1.346zM1.346 20.192c0 1.114.906 2.02 2.02 2.02h8.076v1.346H3.365A3.37 3.37 0 010 20.192V3.365A3.37 3.37 0 013.365 0h22.212a3.37 3.37 0 013.365 3.365v2.693h-1.346V3.365a2.022 2.022 0 00-2.02-2.019H3.367c-1.114 0-2.02.906-2.02 2.02v16.826zM4.038 5.358h16.565v1.346H4.038V5.358zm0 2.693h11.729v1.346H4.038V8.05zm0 2.692h5.385v1.346H4.038v-1.346z"
  }));
};

export default IconEvent;